import { render } from "./CorporateFooter.vue?vue&type=template&id=9ec31260&scoped=true&ts=true"
import script from "./CorporateFooter.vue?vue&type=script&lang=ts"
export * from "./CorporateFooter.vue?vue&type=script&lang=ts"

import "./CorporateFooter.vue?vue&type=style&index=0&id=9ec31260&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec31260"]])

export default __exports__